import { render, staticRenderFns } from "./MultipleTextareas.vue?vue&type=template&id=2806a916&scoped=true"
import script from "./MultipleTextareas.vue?vue&type=script&lang=ts"
export * from "./MultipleTextareas.vue?vue&type=script&lang=ts"
import style0 from "./MultipleTextareas.vue?vue&type=style&index=0&id=2806a916&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2806a916",
  null
  
)

export default component.exports